export enum LeadFormFields {
    DESCRIPTION = 'description',
    LEAD_ORIGIN = 'leadOrigin',
    LEAD_TYPE = 'leadType',
    CAMPAIGN = 'campaign',
    PRODUCTS = 'products',
    NUMBER_OF_PRODUCTS = 'numberOfProducts',
    WINDOWS_BUILT_IN = 'windowsBuiltIn',
}
